module.exports = __webpack_public_path__ + "img/Wien junior.2c255f72.jpg";